

import { Panzoom } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

// Add `Controls` plugin
import { Controls } from "@fancyapps/ui/dist/panzoom.controls.esm.js";
// import "@fancyapps/ui/dist/panzoom.controls.css";





jQuery(function($){

	if( $('#myPanzoom').length ) {

        Panzoom.Plugins = {
            Controls
        };
        
        const myPanzoom = new Panzoom(document.querySelector("#myPanzoom"), {
            // baseScale: 0.5,
            // minScale: 0,
            // maxScale: 10,
            // Your options go here
            // touch: !0,
            // zoom: !0,
            // pinchToZoom: !0,
            // panOnlyZoomed: !1,
            // lockAxis: !1,
            // friction: 0.64,
            // decelFriction: 0.88,
            // zoomFriction: 0.74,
            // bounceForce: 0.2,
            // step: 0.5,
            // textSelection: !1,
            // click: "toggleZoom",
            // wheel: "zoom",
            // wheelFactor: 42,
            // wheelLimit: 5,
            // draggableClass: "is-draggable",
            // draggingClass: "is-dragging",
            // ratio: 1,
        });

	}

});